<div class="redirection-wrapper por">
    @if (loadingRecords) {
    <por-busy-indicator [message]="message"></por-busy-indicator>
    } @if (!loadingRecords) {
    <div>{{ message }}</div>
    }
</div>
